function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );
//requireAll( require.context( './png/', true, /\.png$/) );
requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );

import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import objectFitImages from 'object-fit-images';
// import WebFont from 'webfontloader';
import HappyFocus from 'happy-focus';

import Swiper, { FreeMode } from 'swiper';
import Sortable from 'sortablejs';

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {

				objectFitImages();

				// WebFont.load({
				// 	google: {
				// 		families: ['Roboto', 'Roboto Slab']
				// 	},
				// 	custom: {
				// 	//	families: ['Cera', 'Other']
				// 	}
				// });

				const happyfocus = new HappyFocus();

				PROJECT.quizBuild.init();
				PROJECT.quizInfo.init();
				PROJECT.quizSlider.init();
				PROJECT.quizTab.init();
				PROJECT.quizPuzzle.init();
				PROJECT.quizQuestions.init();

			}

		},

		quizBuild: {

			init: function() {

				if( localStorage.getItem("quizKalsbeeks") !== null ) {

					var currentLocal = localStorage.getItem("quizKalsbeeks");

					currentLocal = JSON.parse( currentLocal );	

					$(currentLocal).each( function(index, value) {


						var questionParent = $('.v-question[data-question-num="'+ value +'"]');
						var slideParent = $('.v-slide[data-question-num="'+ value +'"]');
						var letterParent = $('.s-quiz__puzzle-letter[data-question-num="'+ value +'"]');

						questionParent.addClass('correct');
						slideParent.addClass('v-slide--anwserd');
						letterParent.addClass('s-quiz__puzzle-letter--correct');

					})


				}


				// if( localStorage.getItem("quizStartd") !== null ) {

				// 	// jQuery('#quiz-intro').addClass('s-quiz__intro--close');

				// }


				if( localStorage.getItem("quizeFinished") !== null ) {

					$('#jsPuzzle').addClass('s-quiz__puzzle--show');
					$('.s-quiz__quiz').addClass('s-quiz__quiz--hidden');
					$('#jsPuzzle').addClass('s-quiz__puzzle--correct correct');

				}

			},

		},

		quizInfo: {

			init: function() {

				jQuery('#jsOpenInfo').click(function() {

					PROJECT.quizInfo.open();

				});

				jQuery('#jsCloseInfo').click(function() {

					PROJECT.quizInfo.close();

				});

			},

			open: function() {

				jQuery('#quiz-intro').fadeIn(300).removeClass('s-quiz__intro--close');
				jQuery('body').removeClass('body-scroller');


			},

			close: function() {

				jQuery('#quiz-intro').fadeOut(300).addClass('s-quiz__intro--close');
				jQuery('body').addClass('body-scroller');

				// if( localStorage.getItem("quizStartd") === null ) {

				// 	localStorage.setItem('quizStartd', JSON.stringify('started'));

				// }

			}

		},

		quizSlider: {

			init: function() {

				const swiper = new Swiper('#jsQuistionSlider', {
					modules: [FreeMode],
					loop:false,
					slidesPerView:"auto",
					spaceBetween: 10,
					allowTouchMove: true,
					freeMode: true,

				});	

			}

		},

		quizTab: {

			init: function() {

				jQuery('.v-slide').click(function(e) {

					PROJECT.quizTab.tab(this);

				});

			},

			tab: function(element) {

				if ( $('.jsQuestionTab').length > 0 ) {

					$('.jsQuestionTab').each( function() {

						if( $(this).data('question-num') === $(element).data('question-num') ) {

							$(this).addClass('v-question--show');

						}else {

							$(this).removeClass('v-question--show');

						}

					});

				}

				if( $(element).data('question-num').length > 0 ) {

					console.log('test');

				}

			}

		},

		quizQuestions: {

			init: function() {

				$('.v-question__input').submit( function(event) {

					PROJECT.quizQuestions.onFormSubmit(event);

				});

			},

			onFormSubmit: function(event) {
				
				event.preventDefault();
				
				var formTarget = event.target;
				var inputId	= $(formTarget).find("input[name='questionId']");
				var inputAwnser	= $(formTarget).find("input[name='awnserQuestion']");

				if( $(inputId).length > 0) {

					var questionId = $(inputId).val();
					var anweser = $(inputAwnser).val();

					var anwserLower = obj[questionId]['anwesers'].map(element => {

						return element.toLowerCase();

					});

					var questionParent = $('.v-question[data-question-num="'+ questionId +'"]');
					var slideParent = $('.v-slide[data-question-num="'+ questionId +'"]');
					var letterParent = $('.s-quiz__puzzle-letter[data-question-num="'+ questionId +'"]');

					if( anwserLower.indexOf( anweser.toLowerCase() ) !== -1 ) {

						questionParent.fadeIn(300).addClass('correct');
						slideParent.addClass('v-slide--anwserd');
						letterParent.addClass('s-quiz__puzzle-letter--correct');

						if( localStorage.getItem("quizKalsbeeks") !== null ) {

							var currentLocal = localStorage.getItem("quizKalsbeeks");

							currentLocal = JSON.parse( currentLocal );
						
							currentLocal.push( questionId );

							currentLocal = [...new Set(currentLocal)];

							localStorage.setItem('quizKalsbeeks', JSON.stringify(currentLocal));
		
						} else {

							var initArray = JSON.stringify(
								[ questionId ]
							);
		
							localStorage.setItem('quizKalsbeeks', initArray );


						}

					}else {

						questionParent.addClass('wrong');

						setTimeout(() => {

							questionParent.removeClass('wrong');

						}, 4200);

					}

				}
				

			}

		},
		
		quizPuzzle: {

			init: function() {
				
				jQuery('.jsOpenPuzzle').click(function(e) {

					PROJECT.quizPuzzle.open(this);

				});

				jQuery('.jsClosePuzzle').click(function(e) {

					PROJECT.quizPuzzle.close(this);

				});

				$('.s-quiz__puzzle-input').submit( function(event) {

					PROJECT.quizPuzzle.onFormSubmit(event);

				});

				Sortable.create($('.s-quiz__puzzle-letters')[0],{

					chosenClass: "s-quiz__puzzle-letter--chosen",

				});

			},

			open:function(element) {

				if ( $('#jsPuzzle').length > 0 ) {

					$('#jsPuzzle').addClass('s-quiz__puzzle--show');
					$('.s-quiz__quiz').addClass('s-quiz__quiz--hidden');

				}

			},

			close:function(element) {

				if ( $('#jsPuzzle').length > 0 ) {

					$('#jsPuzzle').removeClass('s-quiz__puzzle--show');
					$('.s-quiz__quiz').removeClass('s-quiz__quiz--hidden');

				}

			},

			onFormSubmit: function(event) {
				
				event.preventDefault();
				
				var formTarget = event.target;
				var inputAwnser	= $(formTarget).find("input[name='awnser']");

				if( $(inputAwnser).length > 0) {

					var anweser = $(inputAwnser).val();

					if( anweser.toLowerCase() === 'kalsbeek!') {

						$('#jsPuzzle').addClass('s-quiz__puzzle--correct correct');

						if( localStorage.getItem("quizeFinished") === null ) {

							localStorage.setItem('quizeFinished', JSON.stringify('Finished'));
		
						}

					}else {

						$('#jsPuzzle').addClass('s-quiz__puzzle--wrong wrong');

						setTimeout(() => {

							$('#jsPuzzle').removeClass('s-quiz__puzzle--wrong wrong');

						}, 4200);
						

					}

				}
				

			}

		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

